import { gql } from "@apollo/client";
import { DefaultFailureTypesIds } from "constants/constants";

export const getRCASettings = gql`
    query getRCASettings($whereUser: user_bool_exp!) {
        production_line {
            production_line_id
            name
            mill {
                mill_id
                name
            }
            rca_settings (where: { failure_type: { deleted_at: { _is_null: true } } }) {
                rca_settings_id
                owner_id
                failure_type {
                    failure_type_id
                    name
                    default_failure_type_translations {
                        failure_type_id
                        language {
                            language_id
                            name
                        }
                        translated_name
                    }
                }
                rca_duration_trigger {
                    rca_duration_trigger_id
                    is_enabled
                    value
                }
                rca_frequency_trigger {
                    rca_frequency_trigger_id
                    is_enabled
                    value
                    rca_frequency_trigger_unit_id
                }
            }
        }
        failure_type(
            where: {
                failure_type_id: {_nin: [${DefaultFailureTypesIds.ADMIN_SAFETY}, ${DefaultFailureTypesIds.EXTERNAL}, ${DefaultFailureTypesIds.BREAK_END_OF_SHIFT}]}
                _and: [
                    { _or: [{ code: { _neq: "BELOW_TRIGGER" } }, { code: { _is_null: true } }] }
                    { _or: [{ code: { _neq: "NOT_SELECTED" } }, { code: { _is_null: true } }] }
                ]
                deleted_at: { _is_null: true }
            }
        ) {
            failure_type_id
            name
            default_failure_type_translations {
                failure_type_id
                language {
                    language_id
                    name
                }
                translated_name
            }
        }
        user(where: $whereUser) {
            user_id
            first_name
            last_name
            mill_id
            user_type_id
            media {
                media_id
                media_url
            }
        }
        rca_frequency_trigger_unit {
            rca_frequency_trigger_unit_id
            name
            default_rca_frequency_trigger_unit_translations {
                rca_frequency_trigger_unit_id
                language {
                    language_id
                    name
                    code
                }
                translated_name
            }
        }
    }
`;

export const upsertRCASettings = gql`
    mutation upsertRCASettings($rcaSettings: [rca_settings_insert_input!]!) {
        insert_rca_settings(
            objects: $rcaSettings
            on_conflict: {
                constraint: rca_settings_pkey
                update_columns: [owner_id, rca_duration_trigger_id, rca_frequency_trigger_id]
            }
        ) {
            affected_rows
            returning {
                rca_settings_id
            }
        }
    }
`;
